module.exports = __webpack_public_path__ + "static/media/image_8.ad70fb5d.png";